import { defineStore } from 'pinia';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';

export const complementaryProductsStore = defineStore('complementaryProducts', {
  state: (): {
    complementaryProducts: ProductVariantExtended[],
    complementaryBaseProduct: ProductVariantExtended | undefined,
    selectedProducts: string[],
    cacheId: string,
  } => ({
    complementaryProducts: [],
    complementaryBaseProduct: undefined,
    selectedProducts: [],
    cacheId: '',
  }),
  actions: {
    setComplementaryProducts(complementaryProducts: ProductVariantExtended[]) {

      this.complementaryProducts = complementaryProducts; 

    },
    setComplementaryBaseProduct(complementaryBaseProduct: ProductVariantExtended) {

      this.complementaryBaseProduct = complementaryBaseProduct; 

    },
    setCacheId(cacheId: string) {

      this.cacheId = cacheId; 

    },
    toggleSelectedProduct(sku: string) {

      const index = this.selectedProducts.indexOf(sku);

      if (index > -1) {

        this.selectedProducts.splice(index, 1);
      
      } else {

        this.selectedProducts.push(sku);
      
      } 

    },
    clearSelectedProducts() {

      this.selectedProducts = []; 

    },
  },
});
